import $ from "jquery";
//import { vuwer } from "@@assets/scripts/common";

$(() => {
	const $content = $(".page-body");

	// アコーディオンの開閉機能
	const duration = 400;
	$content.children(".wp-block-site-original-list-company").each((i, article) => {
		if($content.length) {
		
			const $article = $(article);
			const $articleBody = $article.children(".wrap");
			const $btnToggle = $article.children(".switch")
			.on("click", (e, toOpen) => {
				if( !toOpen ) {
					toOpen = !$btnToggle.hasClass("is-open");
				}
							
				const method = `slide${toOpen ? "Down" : "Up"}`;
							
				$btnToggle.addClass("is-animating");
							
				new Promise(resolve => {
					$.fn[method].call($articleBody, duration, resolve);
				});
							
				$btnToggle.toggleClass("is-open", toOpen).removeClass("is-animating");
			});

			const key = $article.attr("id");
			$(`#mapbtn_${key}`).on("click", e => {
				$btnToggle.trigger("click", [true]);
			
				//const { smoothScrollBuffer } = vuwer.get("body");
				//const scrollTop = Math.ceil($article.offset().top - smoothScrollBuffer);
				const scrollTop = Math.ceil($article.offset().top);
			
				$(document.scrollingElement).animate({ scrollTop }, { duration });
			});
		}
	});

});
